export default [
  {
    name: 'CategoriesList',
    path: '/settings/categories',
    component: () => import('pages/settings/categories/CategoriesList.vue')
  },
  {
    name: 'CategoriesCreate',
    path: '/settings/categories/new',
    component: () => import('pages/settings/categories/CategoriesForm.vue')
  },
  {
    name: 'CategoriesEdit',
    path: '/settings/categories/:id/edit',
    component: () => import('pages/settings/categories/CategoriesForm.vue')
  }
]
